module.exports = __webpack_public_path__ + "img/0Q3B3793_L_BlackMatted_MockedUp.6d3230b5.jpg";